/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import * as AccordionPrimitive from "@radix-ui/react-accordion";
import { forwardRef } from "react";

export type AccordionItemProps = AccordionPrimitive.AccordionItemProps;

export const AccordionItem = forwardRef<any, AccordionItemProps>(({ ...props }, forwardedRef) => (
	<AccordionPrimitive.Item {...props} ref={forwardedRef} />
));

AccordionItem.displayName = "Accordion.Item";
